import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const PasswordUpdatePage = lazy(() => import("./PasswordUpdatePage"));

const PasswordUpdatePageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <PasswordUpdatePage />
    </Suspense>
  );
};

export default PasswordUpdatePageLazy;
